import { ComplexAggregation } from './';

/**
 *
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */
  policy: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */
  memoData: string;
  /**
   *
   * @type {Array<ComplexAggregation>}
   * @memberof InlineResponse20013
   */
  loyalty: Array<ComplexAggregation>;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */
  offer: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */

  offerData: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */

  personal: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */
  processingPersonalData: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */
  transferPersonalData: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013
   */
  promoData: string;
}

export function InlineResponse20013FromJSON(json: any): InlineResponse20013 {
  return InlineResponse20013FromJSONTyped(json);
}

export function InlineResponse20013FromJSONTyped(json: any): InlineResponse20013 {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    policy: json['policy'],
    memoData: json['memoData'],
    loyalty: json['loyalty'],
    offer: json['offer'],
    offerData: json['offerData'],
    personal: json['personal'],
    processingPersonalData: json['processingPersonalData'],
    transferPersonalData: json['transferPersonalData'],
    promoData: json['promoData'],
  };
}

export function InlineResponse20013ToJSON(value?: InlineResponse20013 | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    policy: value.policy,
    memoData: value.memoData,
    loyalty: value.loyalty,
    offer: value.offer,
    offerData: value.offerData,
    personal: value.personal,
    processingPersonalData: value.processingPersonalData,
    transferPersonalData: value.transferPersonalData,
    promoData: value.promoData,
  };
}
